"use strict";

var _toConsumableArray = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PatternTranslator = void 0;

var base_1 = require("../common/base");

var chunk_1 = require("../../chunk/chunk");

var pattern_1 = require("../common/pattern");

var PatternTranslator = /*#__PURE__*/function (_base_1$Translator) {
  _inherits(PatternTranslator, _base_1$Translator);

  function PatternTranslator() {
    _classCallCheck(this, PatternTranslator);

    return _possibleConstructorReturn(this, _getPrototypeOf(PatternTranslator).apply(this, arguments));
  }

  _createClass(PatternTranslator, [{
    key: "translate",
    value: function translate(chunk, actions) {
      var expression = pattern_1.translateChildren(chunk, actions).join(" ");
      var labels = collectLabels(chunk);
      var actionStr = translateAction(chunk.props["action"], labels, actions);
      return "(".concat(expression, " ").concat(actionStr, ")");
    }
  }]);

  return PatternTranslator;
}(base_1.Translator);

exports.PatternTranslator = PatternTranslator;

function translateAction(action, labels, actions) {
  var labels_param = labels.length === 0 ? "" : "".concat(labels.join(", "), ", ");
  var key = "action".concat(actions.size);
  actions.set(key, action);
  var actionStr = "{ \n        return actions.get(\"".concat(key, "\")({").concat(labels_param, "globalFunction});\n    }");
  return actionStr;
}

function collectLabels(chunk) {
  if (!chunk_1.isChunk(chunk)) {
    return [];
  }

  var labels = [];

  if (chunk.props.label) {
    labels.push(chunk.props.label);
  } else {
    chunk.children.forEach(function (child) {
      labels.push.apply(labels, _toConsumableArray(collectLabels(child)));
    });
  }

  return labels;
}